import React, { useState, useMemo } from 'react'
import Card from 'react-bootstrap/Card'
import { MdChatBubble } from 'react-icons/md'

import { IPostProps } from '../../types'
import { RenderTiers } from '../../components/Tiers/RenderTiers'
import {
  fromNow,
  orderTiers,
  parseLinks,
  useCanManagePosts,
  useCurrentUser,
} from '../../common'

import { PostOptions, PollResult, Comments, VideoPost } from './components'
import { HeadPost, MainActions, Postcontent } from './style'
import { getPostAvatar } from './components/panelFunctions'

const PostComponent: React.FC<IPostProps> = ({ post, events = [] }) => {
  const [showReply, setShowReply] = useState(false)
  const { canManage, loading } = useCanManagePosts()
  const { userId } = useCurrentUser()
  const userName =
    post.userAlias || `${post?.user?.firstName} ${post?.user?.lastName}`
  const parsedBody = useMemo(() => parseLinks(post.body), [post.body])

  if (loading) return null

  const canManagePost = canManage || post.user.id === userId
  return (
    <Card
      id={`post-card-${post.id}`}
      data-cy={post.poll ? 'post-card-poll' : 'post-card'}
      className="shadow-sm rounded mb-2 feed-post"
    >
      <Card.Body className="p-2 p-md-3">
        <HeadPost>
          {canManagePost && <PostOptions key={post.id} post={post} />}

          {getPostAvatar({ post })}
          <div className="info">
            <h5 className="mb-0 fz-16">{userName}</h5>
            <small className="text-muted">{fromNow(post.insertedAt)}</small>
          </div>
          <RenderTiers
            tags={orderTiers(post.tiers)}
            eventId={post.eventId}
            events={events}
          />
        </HeadPost>
        <Postcontent className="mb-1 pb-3 pt-1 px-1">{parsedBody}</Postcontent>
        {post.video && <VideoPost video={post.video} />}
        {post.poll && <PollResult owned={canManagePost} post={post} />}

        <MainActions className="fz-13 fwsb">
          <span onClick={() => setShowReply(true)} className="cursor p-2">
            <MdChatBubble size={16} /> Comment
          </span>
        </MainActions>
        <Comments
          reply={showReply}
          count={post.commentCount}
          commentsPreview={post.commentsPreview}
          postId={post.id}
        />
      </Card.Body>
    </Card>
  )
}

export default PostComponent
